const motivationalStatements = [
	// Month 1: Preparation, Focus & New Beginnings (1-31)
	"New day, new roads to explore. Ride with confidence today!",
	"Make safety your first priority on every single trip.",
	"Your dedication keeps the city moving. Thank you for your work!",
	"A great ride starts with a clear mind and a secure helmet.",
	"Every destination is an opportunity to deliver excellence.",
	"Keep your eyes on the road and your goals in sight.",
	"Small steps today lead to big miles tomorrow. Keep pushing!",
	"The best route is always the safest route.",
	"Success is built one delivery, one turn, and one smile at a time.",
	"Every mile you ride is a testament to your hard work.",
	"Stay alert, stay safe, and let your energy shine.",
	"Challenges are just detours on the path to success.",
	"Your work connects people. Take pride in the bridges you build.",
	"Ride safe, stay focused, and own the road today.",
	"No matter the traffic, keep a calm heart and a steady hand.",
	"A friendly smile at the door makes all the difference.",
	"Every trip you complete is a victory. Keep stacking them up!",
	"You are the heartbeat of the logistics network.",
	"Preparation is key. Check your gear, check your ride, and let's go.",
	"Let your attitude be as bright as your high-visibility vest.",
	"A smooth ride is a safe ride. Take it steady today.",
	"Every customer delivery is a job well done. Be proud of it.",
	"The road ahead is yours to conquer. Drive safely!",
	"Keep moving forward. Progress is progress, no matter the speed.",
	"Your positive energy is just as important as your speed.",
	"Be the reason someone smiles today when they open the door.",
	"Focus on the journey, and the results will take care of themselves.",
	"Safety isn't an option; it is our way of life.",
	"Drive with purpose, deliver with care, and return with pride.",
	"Your consistency is your superpower. Keep it up!",
	"Another day to prove what you are capable of. Let's ride!",

	// Month 2: Energy, Speed & Precision (32-60)
	"Fuel your day with positive thoughts and smooth riding.",
	"Speed is good, but precision and safety are excellent.",
	"Patience on the road is the ultimate form of wisdom.",
	"Your hard work today creates a better tomorrow.",
	"Stay focused on the present moment and ride with care.",
	"A professional rider is a safe and courteous rider.",
	"Great things never came from comfort zones. Keep moving!",
	"A clean bike, clear mind, and a safe route make a perfect day.",
	"Deliver happiness, promptness, and reliability today.",
	"Your diligence makes the community stronger every day.",
	"Keep your wheels turning and your spirits high.",
	"Make every turn a demonstration of your road mastery.",
	"The city relies on your dedication. You've got this!",
	"Drive safe, respect others on the road, and shine bright.",
	"Every delivery is a story of connection. You make it happen.",
	"Patience is your best companion in heavy traffic.",
	"Your daily efforts build the foundation of your success.",
	"A positive mindset makes the longest routes feel short.",
	"Stay alert: look twice, ride safe, and deliver with pride.",
	"Keep a steady pace. Consistency beats temporary speed.",
	"Your journey is unique. Enjoy the ride and stay safe.",
	"Every package you deliver is a promise kept.",
	"Maintain your focus, honor your route, and ride securely.",
	"Your commitment inspires everyone around you.",
	"Smooth acceleration, gentle braking, safe arrival.",
	"Let your daily success speak for your dedication.",
	"Stay positive, work hard, and make today count.",
	"Courteous riding is contagious. Spread the good vibes.",
	"Every day is a fresh map to draw your success upon.",

	// Month 3: Resilience & Tenacity (61-91)
	"Rain or shine, your commitment never wavers. You are amazing!",
	"Stay resilient, stay strong, and keep moving forward.",
	"Every hurdle is a chance to show your adaptability.",
	"Wind in your face, determination in your heart.",
	"Believe in your skills, respect the traffic, and ride safe.",
	"Your persistence pays off with every completed journey.",
	"A difficult road often leads to a beautiful destination.",
	"Keep your chin up and your helmet buckled.",
	"Rise above the traffic and focus on your goal.",
	"Strength is riding forward when the day gets tough.",
	"Your endurance is key to conquering long days.",
	"Stay calm, stay cool, and handle the road with grace.",
	"Every challenge you face makes you a better rider.",
	"No distance is too far for a determined heart.",
	"Keep pushing, keep riding, and stay safe out there.",
	"Your hard work is the fuel that runs this city.",
	"Remember why you started and keep your eyes on the prize.",
	"Obstacles are just opportunities to find better routes.",
	"Be proud of the stamina you display every day.",
	"A tough rider knows how to navigate any storm safely.",
	"Focus on what you can control: your safety and attitude.",
	"Your resilience is a shining example to fellow riders.",
	"Keep steering toward your dreams, one mile at a time.",
	"The road may have bumps, but your spirit is smooth.",
	"Adapt to the traffic, master the road, deliver success.",
	"Your dedication is noticed and deeply appreciated.",
	"Every day is a new chance to surpass your yesterday.",
	"Stay steady, keep breathing, and ride with confidence.",
	"The best views belong to those who enjoy the ride.",
	"Keep your momentum high and your safety standards higher.",
	"You possess the drive to reach any destination.",

	// Month 4: Pride, Service & Reliability (92-121)
	"Deliver with a smile, ride with a purpose.",
	"You are the face of reliable service. Keep it up!",
	"Your professionalism shines through in every interaction.",
	"Take pride in the quality of your service today.",
	"Every timely delivery builds trust and reliability.",
	"Your care for the cargo shows your respect for the customer.",
	"Treat every route as a masterpiece of efficiency.",
	"The city appreciates your swift and safe navigation.",
	"Reliability is doing the right thing even when no one is watching.",
	"Make every customer feel like your only customer.",
	"A great rider is defined by their respect for the road rules.",
	"Your work directly improves the lives of others. Well done!",
	"Strive for excellence, prioritize safety, deliver satisfaction.",
	"You are an essential part of the community's daily life.",
	"Keep your standards high and your safety absolute.",
	"Your efficiency is a key driver of our collective success.",
	"Courteous behavior makes the road a friendlier place.",
	"Every package is someone's expectation. Deliver it with care.",
	"Be a beacon of professional riding on the streets today.",
	"Your contribution makes a huge difference. Thank you!",
	"Excellence is not an act, but a daily habit on the road.",
	"Keep your focus sharp, your bike ready, and your spirit high.",
	"The satisfaction of a job well done is the best reward.",
	"Stand tall, ride safe, and deliver with pride.",
	"Your integrity on the road builds a lasting reputation.",
	"Efficiency is smart routing combined with safe driving.",
	"Make today another showcase of your outstanding service.",
	"Your passion for your work shows in every delivery.",
	"Stay committed to quality, safety, and courtesy.",
	"You bring value to every home you visit.",

	// Month 5: Growth, Learning & Mastery (122-152)
	"Every day on the road is a lesson in navigation and patience.",
	"Master your machine, master your route, master your day.",
	"Learn from every detour and become a smarter rider.",
	"Your experience grows with every mile you cover.",
	"Strive to be a better rider today than you were yesterday.",
	"Knowledge of the streets is your greatest tool.",
	"Continuous improvement leads to ultimate mastery.",
	"Observe the road, anticipate changes, ride defensively.",
	"Your skill level increases with every challenge you conquer.",
	"Seek efficiency, embrace safety, enjoy learning.",
	"Every route taught is a map of future success.",
	"Patience is a skill that pays off on every ride.",
	"Your adaptability is your ticket to a smooth journey.",
	"Take time to maintain your bike; it's your trusted partner.",
	"An active mind stays alert to road hazards.",
	"Every safe return is the ultimate goal of learning.",
	"Mastering the art of calm riding is a superpower.",
	"Grow your capacity to handle any traffic condition.",
	"Your dedication to self-improvement is inspiring.",
	"Learn the shortcuts, but never shortcut your safety.",
	"Observe the best, practice the best, be the best.",
	"Your journey of growth has no speed limits.",
	"Celebrate your progress, no matter how small.",
	"A wise rider knows that safety is the ultimate skill.",
	"Keep refining your technique for a smoother ride.",
	"Your expertise on these roads is unmatched.",
	"Stay curious, stay safe, and keep improving.",
	"Every challenge is a lesson disguised as traffic.",
	"Invest in your safety; it's the best investment.",
	"Your growth as a rider is a journey of pride.",
	"Keep learning, keep riding, and keep shining.",

	// Month 6: Mindfulness, Safety & Alertness (153-182)
	"Stay present in the moment; the road demands your focus.",
	"Alertness is your shield against the unexpected.",
	"Drive defensively and expect the unexpected today.",
	"Keep a safe distance; time to react is time to save lives.",
	"Your safety is the foundation of your family's happiness.",
	"Mindful riding keeps you safe and reduces stress.",
	"Keep your eyes scanning, your mind active, and hands ready.",
	"A split second of caution can prevent a lifetime of regret.",
	"Respect the speed limits; they are designed for your protection.",
	"Your life is precious. Ride with extreme care today.",
	"Stay safe, stay focused, and stay alert on the streets.",
	"Check your mirrors constantly; know your surroundings.",
	"A proactive rider avoids accidents before they happen.",
	"Maintain a calm demeanor, even when others don't.",
	"Your health and safety are our top priorities.",
	"Never rush at the expense of your well-being.",
	"Watch out for blind spots, both yours and others'.",
	"Keep your mind on the ride, not on the phone.",
	"A safe rider is a blessing to everyone on the road.",
	"Use your indicators; communication prevents collisions.",
	"Patience in traffic is a sign of a professional.",
	"Be visible: use your lights and wear bright clothing.",
	"Your focus today ensures a safe return tonight.",
	"Scan the road ahead for potential hazards constantly.",
	"A steady ride is always better than a risky rush.",
	"Protect yourself, protect your bike, protect others.",
	"Your judgment is your best safety feature.",
	"Stay sharp, ride smart, and arrive safely.",
	"Respect all road users; we all share the journey.",
	"Safety is a commitment you make before every ride.",

	// Month 7: Motivation, Passion & Joy (183-213)
	"Find joy in the journey and satisfaction in the delivery.",
	"Your energy is contagious; bring positivity to the road.",
	"Passion for the ride makes every mile a pleasure.",
	"Start your day with a grateful heart and a ready engine.",
	"You are doing important work; let that motivate you.",
	"Enjoy the breeze, the scenery, and the satisfaction of work.",
	"Your dedication is the engine of our service. Fuel it well!",
	"Let your enthusiasm guide you to a successful day.",
	"Every delivery completed is a testament to your drive.",
	"Find inspiration in the people you meet along the way.",
	"Your work has purpose; you connect lives and businesses.",
	"Stay motivated, stay energized, and enjoy the adventure.",
	"A positive attitude turns a job into a rewarding passion.",
	"Celebrate the small wins: a green light, a happy customer.",
	"Your smile at the door is a ray of sunshine for many.",
	"Be proud of your stamina and your dedication.",
	"Let your passion for riding fuel your work ethic.",
	"Every day is an opportunity to make someone's life easier.",
	"Your energy keeps this business rolling. Thank you!",
	"Find happiness in the smooth execution of your duties.",
	"A motivated rider is an unstoppable force for good.",
	"Enjoy the freedom of the road and the pride of service.",
	"Your dedication is the key to unlocking your potential.",
	"Make today a masterpiece of joy, safety, and efficiency.",
	"Your work is essential, and you do it beautifully.",
	"Let your spirit be as strong as your engine.",
	"Find satisfaction in every successful route completed.",
	"Your positive energy is your best asset on the road.",
	"Stay driven, stay safe, and enjoy every single mile.",
	"The road is your canvas; paint it with excellent service.",
	"Your joy in working is reflected in the smiles of customers.",

	// Month 8: Focus, Determination & Success (214-244)
	"Keep your goals clear and your focus unwavering today.",
	"Determination is the key to conquering any route.",
	"Every delivery is a step toward your personal success.",
	"Stay focused on the road ahead and ignore distractions.",
	"Your hard work today prepares you for a brighter tomorrow.",
	"Believe in your ability to handle any situation safely.",
	"Success is the sum of small efforts repeated daily.",
	"Keep your eyes on the prize and ride with confidence.",
	"Your determination is stronger than any traffic jam.",
	"Strive for progress, not perfection, on every trip.",
	"Focus on the journey and celebrate every milestone.",
	"Your commitment to excellence is what sets you apart.",
	"Stay driven, work smart, and make your dreams happen.",
	"Every mile you cover is a proof of your endurance.",
	"Your dedication is the foundation of your accomplishments.",
	"Keep moving forward with a heart full of determination.",
	"Success belongs to those who ride for it with passion.",
	"Stay focused, stay safe, and let your results speak.",
	"Your hard work is paving the way to a great future.",
	"Believe in yourself, respect the road, and achieve today.",
	"Every successful delivery is a badge of your honor.",
	"Keep your momentum going and your focus sharp.",
	"Your drive is the key to unlocking new opportunities.",
	"Stay committed to your path and ride with pride.",
	"Success is a journey we take one safe step at a time.",
	"Your determination inspires those who share the road.",
	"Keep pushing your limits safely and with focus.",
	"Every challenge you overcome is a step toward mastery.",
	"Your work is a vital link in the chain of success.",
	"Stay focused on safety and let your dedication shine.",
	"Your journey is defined by your choices. Choose safety.",

	// Month 9: Community, Connection & Pride (245-274)
	"You connect communities, one delivery at a time.",
	"Be proud of the vital role you play in the city's life.",
	"Your work brings people closer together. Well done!",
	"Take pride in being a reliable link in our community.",
	"Every package you deliver is a connection made real.",
	"Your service is a lifeline for many. Thank you!",
	"Be the friendly face of our service in every neighborhood.",
	"Your dedication builds trust between us and the public.",
	"Take pride in the positive impact of your daily work.",
	"You are a valued ambassador of our brand on the streets.",
	"Every customer you serve is a neighbor you help.",
	"Your professionalism elevates the entire delivery community.",
	"Be proud of your contribution to the local economy.",
	"Your work makes the city a more convenient place to live.",
	"Connection is at the heart of everything we do. Thank you!",
	"Your reliability builds a strong and trusted network.",
	"Take pride in the smiles you bring to people's doors.",
	"You are a key player in keeping the community connected.",
	"Your daily efforts make a real difference in people's lives.",
	"Be proud of the standard of excellence you set.",
	"Every delivery is an opportunity to strengthen community ties.",
	"Your dedication is the glue that holds our service together.",
	"Take pride in your journey and the people you help.",
	"You represent reliability and care on every street.",
	"Your work is a service of connection and convenience.",
	"Be proud of the trust customers place in you daily.",
	"Every safe trip is a contribution to a safer community.",
	"Your commitment is the engine of our shared success.",
	"Take pride in the path you've chosen and the work you do.",
	"You are a vital part of our delivery family. Thank you!",

	// Month 10: Endurance, Resilience & Safety (275-305)
	"Your endurance is the key to conquering long days.",
	"Resilience is riding forward when the road gets tough.",
	"Stay strong, stay focused, and keep safety first.",
	"Every mile you ride builds your strength and character.",
	"Your persistence is your greatest asset on the road.",
	"Keep a steady pace and protect your energy today.",
	"Resilience is finding the safe way through any obstacle.",
	"Your stamina is a testament to your strong spirit.",
	"Stay calm under pressure and ride with absolute care.",
	"Every challenge is an opportunity to prove your strength.",
	"Your endurance keeps our service moving forward.",
	"Keep your head up and your focus sharp on the road.",
	"Resilience is maintaining high safety standards always.",
	"Your strength is the foundation of your daily success.",
	"Stay steady, keep breathing, and ride with confidence.",
	"Every long route is a chance to show your endurance.",
	"Your persistence pays off with every safe arrival.",
	"Keep pushing forward with safety as your guide.",
	"Resilience is choosing safety even when you're tired.",
	"Your stamina is highly valued and deeply appreciated.",
	"Stay strong, ride smart, and return home safely.",
	"Every hurdle overcome is a boost to your confidence.",
	"Your endurance is a shining example to all of us.",
	"Keep a positive mindset and let resilience guide you.",
	"Safety is the ultimate goal of all your hard work.",
	"Your persistence is what makes you an elite rider.",
	"Stay focused on safety and let endurance carry you.",
	"Every mile covered safely is a victory for resilience.",
	"Your strength and dedication make us proud every day.",
	"Keep your focus clear and your safety absolute.",
	"You have the endurance to reach any goal safely.",

	// Month 11: Safety, Mindfulness & Professionalism (306-335)
	"Prioritize safety over speed in every decision you make.",
	"Mindful driving is the hallmark of a true professional.",
	"Your safety on the road is our greatest concern.",
	"Keep your focus on the road and ride defensively.",
	"A professional rider always respects the rules of the road.",
	"Stay alert and protect yourself and others today.",
	"Mindfulness helps you anticipate and avoid hazards.",
	"Your professionalism is reflected in your safe riding.",
	"Keep your mind clear and your hands ready at all times.",
	"Safety first, safety last, safety always.",
	"A true professional is known for courtesy and safety.",
	"Stay focused, ride smart, and deliver with care.",
	"Mindful riding keeps you alert to the unexpected.",
	"Your dedication to safety is your best quality.",
	"Respect all road signs and protect your well-being.",
	"A safe return is the most important delivery of the day.",
	"Keep your focus sharp and your machine in top shape.",
	"Professionalism is doing your best on every single trip.",
	"Stay present, stay alert, and ride with confidence.",
	"Your safety is the key to a successful career.",
	"Mindful actions prevent accidents and save lives.",
	"Your commitment to professionalism is inspiring.",
	"Keep a safe following distance and ride defensively.",
	"Safety is a habit that ensures a bright future.",
	"A professional rider is a safe asset to the city.",
	"Stay sharp, ride courteously, and arrive securely.",
	"Mindfulness on the road brings peace of mind.",
	"Your safe riding habits protect your livelihood.",
	"Keep your focus on safety and let excellence follow.",
	"Professionalism and safety go hand in hand.",

	// Month 12: Success, Reflection & New Goals (336-366)
	"Reflect on your achievements and set new goals today.",
	"Success is the reward of your consistent hard work.",
	"Every delivery completed is a step toward your dreams.",
	"Be proud of the progress you've made this year.",
	"Your dedication is paving the way to a bright future.",
	"Keep your momentum high and your focus sharp.",
	"Success is a journey we take together with safety.",
	"Reflect on your growth and celebrate your strength.",
	"Your hard work is the key to your future success.",
	"Keep steering toward your goals with determination.",
	"Success is built on the foundation of daily safety.",
	"Be proud of your resilience and your dedication.",
	"Your commitment to excellence leads to great rewards.",
	"Keep moving forward with a heart full of hope.",
	"Success is the journey of reaching your destinations safely.",
	"Reflect on your safe miles and take pride in them.",
	"Your dedication keeps us moving toward new heights.",
	"Keep your focus on success and your hands on safety.",
	"Every delivery is a brick in the house of your success.",
	"Be proud of the service and reliability you represent.",
	"Your hard work is highly valued and celebrated.",
	"Keep pushing your limits safely and with passion.",
	"Success belongs to those who ride for it with pride.",
	"Reflect on your journey and look forward with joy.",
	"Your dedication is the driving force of our growth.",
	"Keep your spirit bright and your safety absolute.",
	"Success is arriving home safely to those who love you.",
	"Be proud of every mile and every smile you delivered.",
	"Your hard work today is the foundation of tomorrow's wins.",
	"Ride into the future with confidence and safety.",
	"You completed the year's journey. Stand proud, champion!"
];

export default motivationalStatements;
